import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer } from 'react-sortable-hoc';
import SortableRsvpQuestionField from './SortableRsvpQuestionField';

const RsvpQuestionFields = ({
  fields,
  id,
  label,
  hideFormGroup,
  rsvpQuestionCounts,
  onDeleteRsvpQuestion,
  meta: { touched, error },
}) => (
  <div className={`${hideFormGroup ? '' : 'form-group'} ${touched && error ? 'has-error' : ''}`}>
    <label htmlFor={id}>{label}</label>
    <div id={id} className="rsvp-question-list">
      {fields.map((rsvpQuestion, index, fieldsRef) => (
        <SortableRsvpQuestionField
          key={index}
          rsvpQuestion={rsvpQuestion}
          index={index}
          fieldIndex={index}
          fields={fieldsRef}
          rsvpQuestionCounts={rsvpQuestionCounts}
          onDeleteRsvpQuestion={onDeleteRsvpQuestion}
        />
      ))}
    </div>
    <span
      role="button"
      className="text-primary add-rsvp-question"
      onClick={() => fields.push({ question: '', editing: true })}
    >
      + Add Question
    </span>
  </div>
);

RsvpQuestionFields.propTypes = {
  fields: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.element,
  hideFormGroup: PropTypes.bool,
  rsvpQuestionCounts: PropTypes.shape({}),
  onDeleteRsvpQuestion: PropTypes.func,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

const SortableRsvpQuestions = SortableContainer(props => <RsvpQuestionFields {...props} />);

export default SortableRsvpQuestions;



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/SortableRsvpQuestions/SortableRsvpQuestions.jsx